import { IConfigContext } from "./IConfigContext";

import { createContext } from "react";

export const ConfigContext = createContext<IConfigContext>(null!);
